import { useFormik } from "formik";
import React, { useEffect, useMemo } from "react";
import * as moment from "moment";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Select from 'react-select';
import { Box, Button, Flex, Grid, Spinner, Text, useColorMode } from "theme-ui";
import * as Yup from "yup";
import { RootState, usersProps } from "../../../../@types";
import { createStepTwo, getAllProjectNoPagination, getProjectByIdSuccess, getStageCountsByDate } from "../../../store/actions/project.action";
import { getAllUserWithoutPagination } from "../../../store/actions/user.action";
import theme from "../../../theme";
import { addBusinessDays } from "../../../utils/GenerateQueryString";
import { Inputform } from "../../forms-component/InputForm";
import { customStyles, customStylesForDepartments } from "../../pages/createProject/StepTwo/CustomSelectStyles";
interface props {
    next: () => void;
}
const StageStep: React.FC<props> = ({ next }) => {
    const userData = useSelector((state: RootState) => state.project);
    const { userData: userState } = useSelector((state: RootState) => state.user);
    const { projectData, isStageLoader, getproject } = useSelector((state: RootState) => state.project);
    const { projectId } = useParams<{ projectId: string }>();
    const dispatch = useDispatch();
    const { createprojectMasterData, stageCounts } = useSelector((state: RootState) => state.project);
    const { auther } = useSelector((state: RootState) => state.auth);
    const isAllowedToSelectRedDates = auther?.priorityDueDateAccess;
    const allStages = userData.createprojectMasterData?.allStages?.data || [];
    const filteredStages = allStages.filter((stage) => {
        if (getproject?.isMEP && stage?.isMEP) return true;
        if (getproject?.isStructural && stage?.isStructural) return true;
        if (getproject?.isFireSprinkler && stage?.isFireSprinkler) return true;
        if (!getproject?.isMEP && !getproject?.isStructural && !getproject?.isFireSprinkler) return true;
        return false;
    });
    const allTask = userData.createprojectMasterData?.allTask?.data || [];
    const projectManagers = userData.createprojectMasterData?.allProjectManagers || [];
    // const projectWorkers = userData.createprojectMasterData?.allProjectWorkers || [];
    const salesReps = (userState?.data || []).filter((user: usersProps & { role?: { name: string } }) =>
        user?.role?.name === 'Sales Representative' ||
        user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
    );
    const allStagesOptions = filteredStages.map((stage) => ({ value: stage._id, label: stage.name, color: stage.color, backgroundColor: "#445adc", task: [] as Array<{ value: string; label: string; color: string }>, dueDate: '', clientDueDate: '', promise: '', manager: '', worker: '', salesRepresentative: '', isIPR: stage.isIPR }));
    const allTaskOptions = allTask.map((stage) => ({ value: stage._id, label: stage.name, color: stage.color, department: [] as string[] }));
    const promise = [
        { label: "Customer", value: "Customer" },
        { label: "Personal", value: "Personal" },
        { label: "Hot Promise", value: "hotPromise" },
    ];
    const allProjects = (projectData?.data || []).map((project: { _id: string; name: string }) => ({
        value: project?._id,
        label: project?.name
    }))
    const projectManagerOptions = projectManagers.map((manager) => ({
        value: manager._id,
        label: `${manager?.FirstName} ${manager?.LastName}`
    }));
    const salesRepOptions = salesReps.map((rep: usersProps) => ({
        value: rep._id,
        label: `${rep?.FirstName || ''} ${rep?.LastName || ''}`.trim()
    }));
    useEffect(() => {
        dispatch(getAllProjectNoPagination())
        dispatch(getProjectByIdSuccess({}));
        dispatch(getStageCountsByDate());
        dispatch(getAllUserWithoutPagination());
    }, [])

    interface StageItem {
        value: string;
        label: string;
        color: string;
        task: Array<{ value: string; label: string; color: string }>;
        dueDate: string;
        clientDueDate: string;
        isIPR: boolean;
        promise: string;
        manager: string | { _id: string } | null;
        worker: string | { _id: string } | null;
        salesRepresentative: string | { _id: string } | null;
    }

    const validationSchema = useMemo(() => Yup.object({
        stagesData: Yup.array()
            .min(1, "Select at least one stage")
            .of(
                Yup.object().shape({
                    task: Yup.array().min(1, "Select at least one task"),
                    dueDate: Yup.string()
                        .required("Due Date is required")
                        .test('high-volume-check', 'Date is fully booked.', (value) => {
                            if (!value || isAllowedToSelectRedDates) return true;
                            const date = (moment as unknown as (val?: moment.MomentInput) => moment.Moment)(value);
                            if (!date.isValid()) return true;
                            const dateStr = date.format('YYYY-MM-DD');
                            const count = (stageCounts as Record<string, number>)?.[dateStr] || 0;
                            return count < 35;
                        }),
                    clientDueDate: Yup.string().required("Client Due Date is required"),
                    promise: Yup.string().required("Promise is required"),
                    salesRepresentative: Yup.string().required("Sales Representative is required"),
                    // manager: Yup.string().required("Manager is required"),
                })
            ),
    }), [stageCounts, isAllowedToSelectRedDates]);

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema,
        initialValues: {
            stagesData: [] as StageItem[],
        },
        onSubmit: async (values) => {

            const stagesData = values?.stagesData?.map((selectedStage) => {

                const taskData = selectedStage?.task?.map((selectedTask) => {

                    return {
                        id: selectedTask?.value,
                        name: selectedTask?.label,
                        color: selectedTask?.color,
                        isIPR: selectedStage?.isIPR,
                    };
                });

                return {
                    id: selectedStage?.value,
                    name: selectedStage?.label,
                    isIPR: selectedStage?.isIPR,
                    task: taskData,
                    dueDate: selectedStage?.dueDate,
                    clientDueDate: selectedStage?.clientDueDate,
                    worker: (typeof selectedStage?.salesRepresentative === 'object' && selectedStage?.salesRepresentative ? (selectedStage?.salesRepresentative as { _id: string })._id : selectedStage?.salesRepresentative) || (typeof selectedStage?.worker === 'object' && selectedStage?.worker ? (selectedStage?.worker as { _id: string })._id : selectedStage?.worker) || null,
                    salesRepresentative: (typeof selectedStage?.salesRepresentative === 'object' && selectedStage?.salesRepresentative ? (selectedStage?.salesRepresentative as { _id: string })._id : selectedStage?.salesRepresentative) || (typeof selectedStage?.worker === 'object' && selectedStage?.worker ? (selectedStage?.worker as { _id: string })._id : selectedStage?.worker) || null,
                    manager: (typeof selectedStage?.manager === 'object' && selectedStage?.manager ? (selectedStage?.manager as { _id: string })._id : selectedStage?.manager) || null,
                    promise: selectedStage?.promise,
                    color: selectedStage?.color
                };
            });

            if (!isStageLoader) {
                dispatch(createStepTwo({ stagesData, page: 'step2' }, projectId, formik,
                    (res: { status: number }) => {
                        if (res.status === 200) {
                            toast.success("Step Two completed Successfully");
                            next();
                            // navigate("/create-project?step=3&id=" + parsed?.id)
                        }
                    }
                ));

            }
        },

    });
    const handleNextClick = () => {
        handleSubmit();

    };

    const { handleSubmit, setFieldValue, handleChange, setFieldTouched, handleBlur, touched, values, errors } = formik;
    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";
    return (

        <Box className="container-fluid" sx={{ backgroundColor: modalHeader }}>
            <form onSubmit={handleSubmit}>
                {!projectId &&
                    <p>
                        <label className="form-label">Select Project</label>
                    </p>
                }
                <label className="form-label" style={{ color: titleHeader }}>Select Stages</label>
                <Select
                    isMulti
                    classNamePrefix="an-simple-select"
                    value={formik?.values?.stagesData}
                    options={allStagesOptions}
                    aria-labelledby="Select"
                    onChange={(selected) => {
                        const existingStages = formik.values.stagesData || [];
                        const updatedStages = (selected as readonly StageItem[] || []).map((item) => {
                            const existing = existingStages.find((stage) => stage.value === item.value);
                            if (existing) {
                                return existing;
                            }
                            return {
                                ...item,
                                salesRepresentative: (getproject?.salesRepresentative && typeof getproject.salesRepresentative === 'object' ? getproject.salesRepresentative._id : getproject?.salesRepresentative) ?? null,
                                manager: (getproject?.projectManager) ?? null,
                            };
                        });
                        formik?.setFieldValue("stagesData", updatedStages);
                    }}
                    styles={customStylesForDepartments}
                />
                {touched.stagesData && errors.stagesData && (
                    <Text variant="Inter15Regular30lh" className="text-danger" sx={{ fontSize: 17, lineHeight: "10px" }}>
                        {!(typeof errors.stagesData === 'object') ? errors.stagesData : ''}
                    </Text>
                )}
                {/* parent boxes */}

                {values?.stagesData?.map((selectedStage, stageIndex) => {
                    return (
                        <Box key={selectedStage?.value} sx={{
                            boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06);',
                            borderRadius: '12px', p: 2, marginTop: 2
                        }}>
                            <Box key={selectedStage?.value} sx={{ boxShadow: 'initial', p: 2, borderLeft: `4px solid ${selectedStage.color}`, }}>
                                <Flex sx={{ alignItems: 'center', marginBottom: 2 }}>
                                    <Box sx={{ height: '100%', width: '4px', backgroundColor: selectedStage.color, marginRight: '8px' }} />
                                    <Text as={'h3'} sx={{ color: selectedStage.color, marginBottom: 0 }}>
                                        {selectedStage.label}
                                    </Text>
                                </Flex>
                                <label className="form-label" style={{ color: titleHeader }}>Select Task</label>
                                <Select
                                    isMulti
                                    classNamePrefix="an-simple-select"
                                    options={allTaskOptions}
                                    value={formik?.values?.stagesData[stageIndex].task}
                                    aria-labelledby="Select"
                                    onChange={(selected) => {
                                        const updatedStages = formik.values.stagesData.map((stage, mapIndex) =>
                                            stageIndex === mapIndex ? { ...stage, task: selected } : stage);
                                        setFieldValue('stagesData', updatedStages);
                                    }}
                                    styles={customStyles}
                                />
                                {touched.stagesData && errors.stagesData && (errors.stagesData[stageIndex] as { task?: string })?.task && (
                                    <Text variant="Inter15Regular30lh" className="text-danger" sx={{ fontSize: 17, lineHeight: "10px" }}>
                                        {(errors?.stagesData?.[stageIndex] as { task?: string })?.task}
                                    </Text>
                                )}

                                <Grid sx={{ gap: '1rem', marginTop: 3 }} columns={[1, 2, 2, 3, 4, 4]}>
                                    <Box>
                                        <Text variant="SelectLabel" sx={{ color: titleHeader }}>Due Date:<span className="mx-1 text-danger">*</span></Text>
                                        <Inputform
                                            inputClassName="custom-datepicker-input"
                                            type="date"
                                            label=""
                                            onBlur={handleBlur}
                                            sx={{ color: titleHeader, dayCounts: stageCounts || {} }}
                                            Name={`stagesData[${stageIndex}].dueDate`}
                                            OnChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const newDate = e.target.value;
                                                setFieldTouched(`stagesData[${stageIndex}].dueDate`, true, false);
                                                setFieldTouched(`stagesData[${stageIndex}].clientDueDate`, true, false);
                                                setFieldValue(`stagesData[${stageIndex}]`, {
                                                    ...selectedStage,
                                                    dueDate: newDate || null,
                                                    clientDueDate: newDate ? addBusinessDays(newDate, 3) : null,
                                                }, true);
                                            }}
                                            values={selectedStage?.dueDate?.split('T')[0] || ''}
                                            Placeholder="yyyy-mm-dd"
                                            touched={touched?.stagesData?.[stageIndex]?.dueDate}
                                            errors={(errors?.stagesData?.[stageIndex] as { dueDate?: string })?.dueDate}
                                        />
                                    </Box>
                                    <Box>
                                        <Text variant="SelectLabel" sx={{ color: titleHeader }}>Client Due Date:<span className="mx-1 text-danger">*</span></Text>
                                        <Inputform
                                            inputClassName="custom-datepicker-input"
                                            type="date"
                                            label=""
                                            onBlur={handleBlur}
                                            sx={{ color: titleHeader }}
                                            Name={`stagesData[${stageIndex}].clientDueDate`}
                                            OnChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                const newDate = e.target.value;
                                                setFieldTouched(`stagesData[${stageIndex}].clientDueDate`, true, false);
                                                setFieldValue(`stagesData[${stageIndex}].clientDueDate`, newDate || null, true);
                                            }}
                                            values={selectedStage?.clientDueDate?.split('T')[0] || ''}
                                            Placeholder="yyyy-mm-dd"
                                            touched={touched?.stagesData?.[stageIndex]?.clientDueDate}
                                            errors={(errors?.stagesData?.[stageIndex] as { clientDueDate?: string })?.clientDueDate}
                                        />
                                    </Box>
                                    <Box>
                                        <Text variant="SelectLabel" sx={{ color: titleHeader }}>Promise:<span className="mx-1 text-danger">*</span></Text>
                                        <Select
                                            classNamePrefix="an-simple-select"
                                            options={promise}
                                            onBlur={handleBlur}
                                            value={promise.find(option => option.value === selectedStage.promise)}
                                            onChange={(selectedOption: { value: string; label: string } | null) => setFieldValue(`stagesData[${stageIndex}].promise`, selectedOption?.value || '')}
                                        />
                                        {touched.stagesData && errors.stagesData && (errors.stagesData[stageIndex] as { promise?: string })?.promise && (
                                            <Text variant="Inter15Regular30lh" className="text-danger" sx={{ fontSize: 17, lineHeight: "10px" }}>
                                                {(errors?.stagesData?.[stageIndex] as { promise?: string })?.promise}
                                            </Text>
                                        )}
                                    </Box>
                                    <Box>
                                        <Text variant="SelectLabel" sx={{ color: titleHeader }}>Sales Representative:<span className="mx-1 text-danger">*</span></Text>
                                        <Select
                                            classNamePrefix="an-simple-select"
                                            value={salesRepOptions.find((option: { value: string; label: string }) => option.value === ((selectedStage.salesRepresentative as unknown as { _id: string } | null)?._id || (selectedStage.salesRepresentative as string | null) || (selectedStage.worker as unknown as { _id: string } | null)?._id || (selectedStage.worker as string | null)))}
                                            options={[{ value: '', label: 'Select Sales Representative' }, ...salesRepOptions]}
                                            onBlur={handleBlur}
                                            onChange={(selectedOption) => {
                                                formik.setFieldValue(`stagesData[${stageIndex}]`, {
                                                    ...selectedStage,
                                                    salesRepresentative: selectedOption?.value || '',
                                                    worker: selectedOption?.value || '',
                                                }, true);
                                            }}
                                        />
                                        {touched.stagesData && errors.stagesData && (errors.stagesData[stageIndex] as { salesRepresentative?: string })?.salesRepresentative && (
                                            <Text variant="Inter15Regular30lh" className="text-danger" sx={{ fontSize: 17, lineHeight: "10px" }}>
                                                {(errors?.stagesData?.[stageIndex] as { salesRepresentative?: string })?.salesRepresentative}
                                            </Text>
                                        )}
                                    </Box>
                                    <Box>
                                        <Text variant="SelectLabel" sx={{ color: titleHeader }}>Project Manager:</Text>
                                        <Select
                                            classNamePrefix="an-simple-select"
                                            placeholder="Select Project Manager"
                                            onBlur={handleBlur}
                                            value={projectManagerOptions.find((option) => option.value === ((selectedStage.manager as unknown as { _id: string } | null)?._id || (selectedStage.manager as string | null)))}
                                            onChange={(selectedOption) =>
                                                formik.setFieldValue(`stagesData[${stageIndex}].manager`, selectedOption?.value || '')}
                                            options={[{ value: '', label: 'Select Manager' }, ...projectManagerOptions]}
                                        />
                                        {touched.stagesData && errors.stagesData && (errors.stagesData[stageIndex] as { manager?: string })?.manager && (
                                            <Text variant="Inter15Regular30lh" className="text-danger" sx={{ fontSize: 17, lineHeight: "10px" }}>
                                                {(errors?.stagesData?.[stageIndex] as { manager?: string })?.manager}
                                            </Text>
                                        )}
                                    </Box>
                                </Grid>
                            </Box>
                        </Box>
                    )
                })}
                <Flex sx={{ justifyContent: "end", paddingBottom: '30px' }} className="mt-4">
                    <Button disabled={isStageLoader} sx={{ background: theme.colors?.primary, padding: '12px 18px', width: "25%" }} type="submit" >{isStageLoader ? <Spinner size={30} sx={{ color: "#fff" }} /> : "Next"}</Button>
                </Flex>
            </form>
        </Box>
    );
};

export default StageStep;
